<div class="iframe-container">
  <iframe class="full-width" src="https://www.iubenda.com/terms-and-conditions/85763951" style=""></iframe>
</div>
